import { number, object, SchemaOf } from 'yup';

import { REQUIRED_FIELD, MUST_BE_NUMBER } from '@/config/text.const';

import { UpdateContractRenewalVariables } from '@/graphql/contracts/_generated_/updateContractRenewal.mutation';
import { getBillingIntervals } from '@/utils/data-helpers/intervals';

export type Fields = Omit<UpdateContractRenewalVariables, 'contractId'>;

interface ValidationContext {
  contractBillingInterval: string;
}

export const validationSchema: SchemaOf<Fields> = object().shape({
  daysBeforeRenewal: number()
    .required(REQUIRED_FIELD)
    .typeError(MUST_BE_NUMBER)
    .integer('Days Before Renewal should be an integer')
    .nullable()
    .test('is-valid-days', 'Invalid days before renewal', function (value) {
      const context = this.options.context as ValidationContext;
      const interval = getBillingIntervals().find((el) => el.billingInterval === context.contractBillingInterval);
      const minDays = interval?.contractDBRLimit.minDays;
      const maxDays = interval?.contractDBRLimit.maxDays;

      if (value && minDays && value < minDays) {
        return this.createError({
          path: 'daysBeforeRenewal',
          message: `Value must be more than or equal to ${minDays}`
        });
      }
      if (value && maxDays && value > maxDays) {
        return this.createError({
          path: 'daysBeforeRenewal',
          message: `Value must be less than or equal to ${maxDays}`
        });
      }
      return true;
    })
});